import { AbstractControl, ValidationErrors } from '@angular/forms';

export class NotEmptyValidator {
    static validate = (control: AbstractControl): ValidationErrors | null => {
      const strVal: string|undefined = (control.value as string)?.trim();
      const isEmpty = strVal === undefined || strVal.length === 0;
      //console.log('validate', isEmpty, strVal);
      return isEmpty? { required: true, notEmpty: true } : null;
    }
}